module.exports = __webpack_public_path__ + "assets/table.2352c12a.svg";